export const chevron_up = () => (
  <path
    d="M18 15l-6-6-6 6"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
